module.exports = "/_next/static/images/lowest_performers-90e05beafbf7765423b7d393a29b89cd.jpeg";